import React from "react";

const ImpartRecommendation = () => {
    const render = () => {
        return (
            <section class="mt-4">
                <div class="container">
                    <h2 class="text-blue h4 font-weight-bold"> Impact <br /> Recommendations</h2>
                    <div class="text-blue font-18">Insights from your latest content analysis.</div>
                    <div class="mt-3 chart-bg border p-4">
                        <div class="bg-white border rounded-10 p-3 mb-3">
                            <div class="text-black">Overall Analysis Summary:</div>
                            <small class="Overall-Analysis-Summary">"Your narrative exhibits a strong overall emotional arc, with key moments effectively leveraging EL3 (Power/Focus) and EL5 (Ego). The Surprise Factor peaks sharply at the climax, ensuring high audience engagement at the narrative's conclusion. However, the mid-story could benefit from introducing more varied emotional triggers to prevent a slight dip in sustained interest."</small>
                        </div>
                        <div class="text-black mb-2"> Actionable Steps to Enhance Impact :</div>
                        <ul class="Steps-Enhance-list">
                            <li>
                                <div><b>Inject Mid-Story Tension (EL1)</b></div>
                                <p>Introduce a surprise setback leveraging **EL1 (Survival)** around the 40-50% mark to re-engage the audience and create a stronger rise to the climax.</p>
                            </li>
                            <li>
                                <div><b>Strengthen Emotional Diversity (EL4)</b></div>
                                <p>Explore moments that trigger **EL4 (Love/Fear)** during character interactions to add depth and create more varied emotional peaks for the audience.</p>
                            </li>
                            <li>
                                <div><b>Optimize Climax Setup</b></div>
                                <p>While the climax S-value is high, review the preceding plot points to ensure the **'Expectation' is well-established** for maximum surprise impact.</p>
                            </li>
                            <li>
                                <div><b>Leverage Strengths (EL3, EL5)</b></div>
                                <p>Continue to effectively utilize **EL3 (Power/Focus)** and **EL5 (Ego)** moments, as these are identified as strong engagement drivers in your content.</p>
                            </li>
                        </ul>
                        <div class="d-flex gap-15">
                            <a class="btn1 rounded" href="#">Implement Recommendations</a>
                            <a class="btn1 d-flex align-items-center gap-15 rounded" href="#">Download Detail Report <span><img src="images/download.svg" alt="" /></span></a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
    return render();
}

export default ImpartRecommendation